// extracted by mini-css-extract-plugin
export default {"header":"aeqzT","client-choice-type":"qe3_K"};